import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "calendar" }
const _hoisted_3 = { class: "calendar__row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.yearMonthLabel), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.headers), (key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: _normalizeClass([key, 'calendar__cell header']),
            style: {"background-color":"#f0f0f0"}
          }, _toDisplayString(_ctx.headers[key]), 3))
        }), 128))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateCells, (cells, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "calendar__row",
          key: i
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cells, (cell) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "calendar__cell body",
              key: cell.id
            }, [
              (cell.shouldShow)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(cell.date) + " ", 1),
                    _renderSlot(_ctx.$slots, "date", {
                      date: cell.date
                    }),
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text",
                      color: cell.isSelected ? 'primary' : 'grey',
                      onClick: ($event: any) => (_ctx.selectDate(cell.date))
                    }, {
                      default: _withCtx(() => [
                        (cell.isSelected)
                          ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                _createTextVNode("mdi-checkbox-marked", -1)
                              ]))]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createTextVNode("mdi-checkbox-blank-outline", -1)
                              ]))]),
                              _: 1
                            }))
                      ]),
                      _: 2
                    }, 1032, ["color", "onClick"])
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}